import React from 'react';
import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import AboutPreview from '../components/AboutPreview';
import ServicesGrid from '../components/ServicesGrid';
import TeamPreview from '../components/TeamPreview';
import WhyCCC from '../components/WhyCCC';
import TherapyMeets from '../components/TherapyMeets';
import Testimonials from '../components/Testimonials';
import LocationSEO from '../components/LocationSEO';
import FinalCTA from '../components/FinalCTA';
import Seo, { organizationSchema } from '../components/Seo';

export default function Home() {
  return (
    <>
      <Seo
        title="Trauma, EMDR & Anxiety Therapy in Chesapeake, VA"
        description="Compassionate counseling in Chesapeake, VA. Trauma therapy, EMDR, anxiety, couples & women’s counseling for individuals and families across Hampton Roads."
        path="/"
        schema={organizationSchema()}
      />
      <Hero />
      <TrustBar />
      <AboutPreview />
      <ServicesGrid limit={6} />
      <TeamPreview limit={4} />
      <WhyCCC />
      <TherapyMeets />
      <Testimonials />
      <LocationSEO />
      <FinalCTA />
    </>
  );
}
